import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayMode, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgke162aRequest, Sgke162aResponseSearchresultList, Sgke163aRequest, Sgke163aRequestReginf, Sgke164aRequest, Sgke164aRequestDelInfo, Sgke165aRequest, Sgke165aRequestReginfList, Sgke903aRequest, Sgke903aResponseCompanyAreaInfo, Sgke903aResponseInitialhyojiInfo,Szza012aRequest, } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSgke903aService } from '../../../../../sg-ke-shared/services/used-sgke903a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';
import { Sgke160dSearchResultComponent } from '../../components/sgke160d-search-result/sgke160d-search-result.component';
import { UsedSgke162aService } from '../../services/used-sgke162a.service';
import { UsedSgke163aService } from '../../services/used-sgke163a.service';
import { UsedSgke164aService } from '../../services/used-sgke164a.service';
import { UsedSgke165aService } from '../../services/used-sgke165a.service';
import { UsedSzza012aService } from '../../../../../sg-ke-shared/services/used-szza012a.service';

@Component({
  selector: 'app-sgke160d',
  templateUrl: './sgke160d.component.html',
  styleUrl: './sgke160d.component.scss'
})
export class Sgke160dComponent implements OnInit, OnDestroy {

  @ViewChild(Sgke160dSearchResultComponent) sgke160dSearchResultComponent!: Sgke160dSearchResultComponent;

  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 画面ID */
  private static GAMEN_ID = 'SGKE160D';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** モード区分_登録 */
  public MODE_CREATE = DisplayMode.create;
  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** モード区分（初期値として登録を設定） */
  mode: string = this.MODE_CREATE;
  /** 入金締め検索APIリクエスト情報 FormGroup */
  searchCndtFormGroup: UntypedFormGroup;
  /** コード変換マスタマップ */
  codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
  /** 会社地区情報 */
  cmpnyAreaList: Array<Sgke903aResponseCompanyAreaInfo>;
  /** 会社地区初期表示情報 */
  cmpnyAreaInit: Sgke903aResponseInitialhyojiInfo;
  /** 検索結果リスト */
  searchresultList: Array<Sgke162aResponseSearchresultList> = new Array<Sgke162aResponseSearchresultList>();
  /** 完了画面名 */
  completionPageTitle: string = '';
  /** 完了画面メッセージ */
  completionPageMessage: string = '';
  /** システム日付 */
  systemDate:Date;
  /** 業務日付取得APIリクエスト */
  requestSzza012a: Szza012aRequest;


  /**
   * コンストラクタ
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {UsedSgke903aService} companyAreaInfoService
   * @param {UsedSgke162aService} searchService
   * @param {UsedSgke163aService} registrationService
   * @param {UsedSgke164aService} cancelService
   * @param {UsedSgke165aService} approvalService
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {UntypedFormBuilder} fb
   * @param {CompleteDataService} completeDataService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd
   * @memberof Sgke160dComponent
   */
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyAreaInfoService: UsedSgke903aService,
    public searchService: UsedSgke162aService,
    public registrationService: UsedSgke163aService,
    public cancelService: UsedSgke164aService,
    public approvalService: UsedSgke165aService,
    public initService: UsedSzza012aService,
    private codeConversionMstService: CodeConversionMstService,
    private fb: UntypedFormBuilder,
    private completeDataService: CompleteDataService,
    private responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
    private timeApiService: TimeApiService,
  ) { }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {

      // 画面遷移元パラメータ取得
      this.mode = params.get('mode');

      // 検索条件Formを初期化
      this.searchCndtFormGroup = this.fb.group({
        requestCommon: new UntypedFormGroup({}),
      });

      // クリア処理
      this.clear();
      this.codeConversionMstMap = null;
      this.cmpnyAreaList = null;

      //コード変換マスタ共通コンポーネント呼び出し
      this.codeConversionMstService.getCodeConversionMst([
        'C00102B',
        'S300570',
      ])
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(data => {
          // ローカルに保存
          this.codeConversionMstMap = data;
        });

      // 会社地区情報取得
      this.getCompanyAreaInfo();

    });

       // リクエスト情報をもつオブジェクトを定義
    this.requestSzza012a = {
      requestCommon: {
        businessDate: null,
        dryRun: false,
        businessReqId: null,
        funcLinkId: null,
        requestCustomize: null,
      },
      businessDayKbn: null,
    };

    // SZZA012A呼び出し
    this.initService
      .doSzza012a(this.requestSzza012a)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (response) => {

          if (response?.todayDay) {
            this.systemDate = this.timeApiService.convertStringToDate(
              response.todayDay
            );
          }

          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);          },
            (error) => {
          }
        );
  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 検索処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  search(): void {
    // メッセージクリア
    this.clearErrorMsg();

    // 検索結果リスト初期化
    this.searchresultList = new Array<Sgke162aResponseSearchresultList>();

    // 活性状態の値を取得
    let request = this.searchCndtFormGroup.getRawValue() as Sgke162aRequest;

    // 動作モードに値を設定
    request.cndt.operatingmode = this.mode == this.MODE_APPROVE ? '1' : '0';

    // SGKE162A呼び出し
    this.searchService.doSgke162a(request)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response?.searchresult?.searchresultList) {
          this.searchresultList = response.searchresult.searchresultList;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
        error => {
        });
  }

  /**
   * クリア処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  clear(): void {
    // メッセージクリア
    this.clearErrorMsg();
    // 検索結果リスト初期化
    this.searchresultList = new Array<Sgke162aResponseSearchresultList>();
  }

  /**
   * 入金締め処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  register(): void {
    // メッセージクリア
    this.clearErrorMsg();

    // 登録情報 生成関数
    let requestFunc = function (row: Sgke162aResponseSearchresultList): Sgke163aRequestReginf {
      return {
        receivemoneyjimeMno: row.receivemoneyjimeMno,
        receivemoneyjimeRrkno: row.receivemoneyjimeRrkno,
        updateSrno: row.updateSrno,
      };
    };

    // 登録リクエスト作成
    let request: Sgke163aRequest = {
      // requestCommonはUsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      reginf: this.searchresultList.map(requestFunc),
    };

    // 完了画面のタイトル設定
    this.completionPageTitle = "入金締め登録完了画面";
    // 完了画面のメッセージ設定
    this.completionPageMessage = "入金締めを登録しました";

    // SGKE163A呼び出し
    this.registrationService.doSgke163a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        error => {
        });

  }

  /**
   * 締め取消処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  cancel(): void {
    // メッセージクリア
    this.clearErrorMsg();

    // 削除情報 生成関数
    let requestFunc = function (row: Sgke162aResponseSearchresultList): Sgke164aRequestDelInfo {
      return {
        receivemoneyjimeMno: row.receivemoneyjimeMno,
        receivemoneyjimeRrkno: row.receivemoneyjimeRrkno,
        updateSrno: row.updateSrno,
      };
    };

    // 取消リクエスト作成
    let request: Sgke164aRequest = {
      // requestCommonはUsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      delInfo: this.searchresultList.map(requestFunc)
    };

    // 完了画面のタイトル設定
    this.completionPageTitle = "入金締め取消完了画面";
    // 完了画面のメッセージ設定
    this.completionPageMessage = "入金締めを取消しました";

    // SGKE164A呼び出し
    this.cancelService.doSgke164a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        error => {
        });

  }

  /**
   * 承認処理
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  approve(): void {
    // メッセージクリア
    this.clearErrorMsg();

    // 登録情報リスト 生成関数
    let requestFunc = function (row: Sgke162aResponseSearchresultList): Sgke165aRequestReginfList {
      return {
        reginf: {
          receivemoneyjimeMno: row.receivemoneyjimeMno,
          receivemoneyjimeRrkno: row.receivemoneyjimeRrkno,
          updateSrno: row.updateSrno,
        }
      };
    };

    // 承認リクエスト作成
    let request: Sgke165aRequest = {
      // requestCommonはUsedService側で設定するため、ここではnullを設定する
      requestCommon: null,
      reginfList: this.searchresultList.map(requestFunc)
    };

    // 完了画面のタイトル設定
    this.completionPageTitle = "入金締め登録完了画面";
    // 完了画面のメッセージ設定
    this.completionPageMessage = "入金締めを承認しました";

    // SGKE165A呼び出し
    this.approvalService.doSgke165a(request).pipe(takeUntil(this.onDestroy$))
      .subscribe(
        this.handleRegistResponse,
        error => {
        });

  }

  /**
   * SGKE903A_会社地区情報取得API呼出し
   * @private
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  private getCompanyAreaInfo(): void {
    let requestInfo: Sgke903aRequest = {
      requestCommon: null,
      reqBusinessArea: {
        gamenId: Sgke160dComponent.GAMEN_ID
      }
    };

    this.companyAreaInfoService.doSgke903a(requestInfo).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response.responseBusinessArea) {
          this.cmpnyAreaList = response?.responseBusinessArea.companyAreaInformationlist;
          this.cmpnyAreaInit = response?.responseBusinessArea.initialhyojiInfo;
        }
        // メッセージを表示
        this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
      },
      error => {
      });

  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  private clearErrorMsg(): void {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

  /**
   * レスポンス共通処理
   * @private
   * @param {any} response 
   * @returns {void}
   * @memberof Sgke160dComponent
   */
  private handleRegistResponse = (response: any): void => {
    if (response) {
      // 登録完了画面情報設定
      this.completeDataService.completeData = {
        title: this.completionPageTitle,
        message: this.completionPageMessage,
        next: '/sgkz001d/',
      };
      // 登録完了画面遷移
      this.router.navigate(['/sgkz003d/'])
    }
  }

}
